<vdw-header svgIcon="warning-full-36px" [title]="'PLANNING.NEEDS_ATTENTION.TITLE' | bmsTranslate" [canShowClose]="true" (closeEvent)="closeMachineDetail()"></vdw-header>
<div class="search-container">
  <vdw-filter #nameFilter filterWidth="100%" icon="filter" [filteredText]="nameFilterChanged.value" (filterIconClicked)="showAdvancedSearch()" (filteredTextChanged)="nameFilterChanged.next($event)">
  </vdw-filter>

  @if (activeSearchFilters.length > 0) {
    <vdw-filter-chips [canDeleteChips]="true" [canMoveChips]="false" [compact]="true" [chips]="activeSearchFilters" [labelGetter]="getChipLabel" (deletedEvent)="removeFilter($event)">
    </vdw-filter-chips>
  }
</div>

<article>
  <virtual-scroller class="full-height" #virtualScroller [items]="filteredOrdersToPlan">
    <div
      *ngFor="let orderToPlan of virtualScroller.viewPortItems"
      class="order"
      [class.active]="dragActive && draggedItem === orderToPlan"
      [draggable]="true"
      (dragstart)="onDragStart($event, orderToPlan, unplannedOrder)"
    >
      <ng-template #unplannedOrder>
        <app-planning-order [order]="orderToPlan"></app-planning-order>
      </ng-template>

      @if (!isToReconfirm(orderToPlan)) {
        <mat-icon svgIcon="drag" class="drag-handle"></mat-icon>
      }

      <div class="text-content">
        <p class="b1 font-weight-semibold" vdw-ellipsis-label [text]="orderToPlan.productionOrder.name" matTooltipPosition="above"></p>
        <p class="b1 product" vdw-ellipsis-label [text]="getProductString(orderToPlan)" matTooltipPosition="above"></p>
        <p class="b2 hint" vdw-ellipsis-label [text]="getRequiredQuantityString(orderToPlan)" matTooltipPosition="above"></p>
      </div>

      @if (isToReconfirm(orderToPlan)) {
        <p class="b1 url warning to-reconfirm" (click)="reconfirmOrder(orderToPlan)">
          {{ 'PLANNING.ACTIONS.RECONFIRM' | bmsTranslate }}
        </p>
        <mat-icon class="cursor-pointer" svgIcon="chevron-right" (click)="openPlannedItemSidebar(orderToPlan)"></mat-icon>
      } @else {
        <p class="b2 font-weight-semibold text-align-center to-plan">
          {{ getStatus(orderToPlan) | bmsTranslate | uppercase }}
        </p>
        <button type="button" mat-icon-button class="mat-icon-action-button-lg-with-border" (click)="deleteUnplannedOrder(orderToPlan)">
          <mat-icon svgIcon="trash"></mat-icon>
        </button>
      }
    </div>
  </virtual-scroller>
</article>
